export default __webpack_public_path__ + "static/media/batch_upload.167214d3.xlsx";